module.exports = __webpack_public_path__ + "img/monad.e45f1a61.svg";